import { render } from "./TextAreaUi.vue?vue&type=template&id=4a487edf&scoped=true"
import script from "./TextAreaUi.vue?vue&type=script&lang=js"
export * from "./TextAreaUi.vue?vue&type=script&lang=js"

import "./TextAreaUi.vue?vue&type=style&index=0&id=4a487edf&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a487edf"]])

export default __exports__